module.exports = __webpack_public_path__ + "static/media/google-icon.2f4b7d79.svg";